import { useState, useEffect, useCallback } from 'react';
import { Radio, Zap } from 'lucide-react';
import { API } from '@/lib/constants';

export default function RaceWeekendToggle() {
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetch(`${API}/race-weekend-mode`)
      .then((res) => res.json())
      .then((data) => setEnabled(data.enabled))
      .catch(() => {});
  }, []);

  const toggle = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API}/race-weekend-mode?enabled=${!enabled}`, { method: 'POST' });
      const data = await res.json();
      setEnabled(data.enabled);
    } catch {
    } finally {
      setLoading(false);
    }
  }, [enabled]);

  return (
    <button
      type="button"
      onClick={toggle}
      disabled={loading}
      data-testid="race-weekend-mode-toggle"
      className={`group inline-flex items-center gap-2 rounded-xl border px-3 py-2 text-xs font-medium transition-all duration-200 ${
        enabled
          ? 'border-[#E74C3C]/40 bg-[#E74C3C]/10 text-[#E74C3C] shadow-[0_0_12px_rgba(231,76,60,0.15)]'
          : 'border-white/10 bg-white/[0.03] text-white/50 hover:bg-white/[0.06] hover:text-white/70'
      }`}
    >
      {enabled ? <Zap className="h-3.5 w-3.5 animate-pulse" /> : <Radio className="h-3.5 w-3.5" />}
      <span>{loading ? '...' : enabled ? 'RACE MODE' : 'Race Mode'}</span>
      <div
        className={`relative h-4 w-8 rounded-full transition-colors ${enabled ? 'bg-[#E74C3C]' : 'bg-white/15'}`}
      >
        <div
          className={`absolute top-0.5 h-3 w-3 rounded-full bg-white transition-transform ${enabled ? 'translate-x-4' : 'translate-x-0.5'}`}
        />
      </div>
    </button>
  );
}
